import { render, staticRenderFns } from "./department_log.vue?vue&type=template&id=004c8142"
import script from "./department_log.vue?vue&type=script&lang=js"
export * from "./department_log.vue?vue&type=script&lang=js"
import style0 from "./department_log.vue?vue&type=style&index=0&id=004c8142&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports